import { VStack } from '@cbhq/cds-web/layout';
import { memo, ReactNode } from 'react';

type SummaryCardProps = {
  header: ReactNode;
  children: ReactNode;
  testID?: string;
};

/**
 * A reusable card component for displaying summary information with a header.
 * Used in Pool Details sidebar (Stats, Earn, Rewards cards) and Equity Details sidebar (Balance, Stats, Info cards).
 */
export const SummaryCard = memo(function SummaryCard({
  header,
  children,
  testID,
}: SummaryCardProps) {
  return (
    <VStack paddingY={3} gap={2} background="bg" borderRadius={300} testID={testID}>
      <VStack paddingX={3}>{header}</VStack>
      <VStack>{children}</VStack>
    </VStack>
  );
});

export default SummaryCard;
